'use client'

import {type EmailCaptureFragment} from '~/cms/helpers/getEmailCaptureProps/_generated/fragments.graphql'
import {getEmailCaptureDestinationProps} from '~/cms/helpers/getEmailCaptureProps/getEmailCaptureDestinationProps'
import {HgEmailCapture} from '~/design-system/hg/components'

export default function ComposableDetailsEmailCapture(props: EmailCaptureFragment) {
  return (
    <div className="col-span-full">
      <HgEmailCapture
        {...getEmailCaptureDestinationProps(props)}
        classNames={{
          successMessage: 'relative top-0 pt-16',
          errorMessage: 'relative top-0 pt-16',
        }}
      />
    </div>
  )
}
